"use strict";exports.CORNER_RADIUS={none:"0px",xxxSmall:"2px",xxSmall:"4px",xSmall:"8px",small:"12px",medium:"16px",large:"20px",xLarge:"24px",rounded:"50%",halfRounded:"1000px"};
//# sourceMappingURL=cornerRadius.js.map
